<template>
  <div class="white mx-0">
    <v-img :src="`${publicPath}imagenes/Rapaces.jpg`" height="100vh"></v-img>
    <div>
      <v-img
        v-show="$vuetify.breakpoint.lg"
        class="mx-0"
        :src="`${publicPath}imagenes/fondora.png`"
      >
        <v-row justify="center">
          <v-col cols="10" sm="7" md="7" lg="8" xl="7" class="pt-12 pb-6">
            <h1 class="display-1 font-weight-bold text-uppercase pb-5">Forma parte del equipo</h1>
            <p
              class="body-1"
              style="text-align:justify;"
            >Colegio Vizcaya quiere fomentar dentro de la comunidad estudiantil, la integración de actividades físicas y recreativas, por tal motivo, nace el proyecto de unificar a los alumnos de nuestra institución dentro de las diferentes disciplinas deportivas. Dentro del sistema Vizcaya contamos con maestros capacitados para desarrollar las diferentes actividades dentro y fuera de cada Plantel , los docentes se encargan de convocar, direccionar y entrenar a los alumnos que muestran interés por alguna disciplina deportiva mostrando audacia, perseverancia, entrega y dedicación.</p>
            <p
              class="body-1"
              style="text-align:justify;"
            >Surge la idea de tener un emblema distintivo, por lo cual, el departamento de Mercadotecnia de Patronato Cultural Vizcaya A.C. , determinó que debían ser representados por una figura que diera identidad propia a la institución, de esta manera nace “Uvaldo” (mascota oficial de Colegio Vizcaya), un águila real de color tinto, con actitud audaz e inteligencia. Todos los equipos deportivos de Colegio y Universidad Vizcaya son conocidos como “Rapaces”, dicha mención obedece a que son identificados como los supremos competidores dentro de las instituciones de los diferentes niveles educativos. Ser parte de Rapaces va más allá de solo pertenecer a un equipo, simboliza la majestuosidad y congregación de elementos claves, tanto físicos como mentales, los cuales, dan un cauce estratégico a los elementos pertenecientes al grupo.</p>
          </v-col>
        </v-row>
      </v-img>
      <v-img
        v-show="$vuetify.breakpoint.md"
        class="mx-0"
        :src="`${publicPath}imagenes/fondora3.png`"
      >
        <v-row justify="center">
          <v-col cols="10" sm="7" md="7" lg="8" xl="7" class="pt-12 pb-6">
            <h1 class="display-1 font-weight-bold text-uppercase pb-5">Forma parte del equipo</h1>
            <p
              class="body-1"
              style="text-align:justify;"
            >La Universidad Vizcaya de las Américas quiere fomentar dentro de la comunidad estudiantil, la integración de actividades físicas y recreativas, por tal motivo, nace el proyecto de unificar a los alumnos de la universidad dentro de las diferentes disciplinas deportivas. Dentro del sistema Vizcaya contamos con maestros capacitados para desarrollar las diferentes actividades dentro y fuera de cada Campus , los docentes se encargan de convocar, direccionar y entrenar a los alumnos que muestran interés por alguna disciplina deportiva mostrando audacia, perseverancia, entrega y dedicación.</p>
            <p
              class="body-1"
              style="text-align:justify;"
            >Surge la idea de tener un emblema distintivo, por lo cual, el departamento de Mercadotecnia de Patronato Cultural Vizcaya A.C. , determinó que debían ser representados por una figura que diera identidad propia a la institución, de esta manera nace “Uvaldo” (mascota oficial de la Universidad Vizcaya de las Américas), un águila real de color tinto, con actitud audaz e inteligencia. Todos los equipos deportivos de Colegio y Universidad Vizcaya son conocidos como “Rapaces”, dicha mención obedece a que son identificados como los supremos competidores dentro de las instituciones de los diferentes niveles educativos. Ser parte de Rapaces va más allá de solo pertenecer a un equipo, simboliza la majestuosidad y congregación de elementos claves, tanto físicos como mentales, los cuales, dan un cauce estratégico a los elementos pertenecientes al grupo.</p>
          </v-col>
        </v-row>
      </v-img>

      <v-img
        v-show="$vuetify.breakpoint.sm"
        class="mx-0"
        :src="`${publicPath}imagenes/fondora4.png`"
      >
        <v-row justify="center">
          <v-col cols="10" sm="7" md="7" lg="8" xl="7" class="pt-12 pb-6">
            <h1 class="display-1 font-weight-bold text-uppercase pb-5">Forma parte del equipo</h1>
            <p
              class="body-1"
              style="text-align:justify;"
            >La Universidad Vizcaya de las Américas quiere fomentar dentro de la comunidad estudiantil, la integración de actividades físicas y recreativas, por tal motivo, nace el proyecto de unificar a los alumnos de la universidad dentro de las diferentes disciplinas deportivas. Dentro del sistema Vizcaya contamos con maestros capacitados para desarrollar las diferentes actividades dentro y fuera de cada Campus , los docentes se encargan de convocar, direccionar y entrenar a los alumnos que muestran interés por alguna disciplina deportiva mostrando audacia, perseverancia, entrega y dedicación.</p>
            <p
              class="body-1"
              style="text-align:justify;"
            >Surge la idea de tener un emblema distintivo, por lo cual, el departamento de Mercadotecnia de Patronato Cultural Vizcaya A.C. , determinó que debían ser representados por una figura que diera identidad propia a la institución, de esta manera nace “Uvaldo” (mascota oficial de la Universidad Vizcaya de las Américas), un águila real de color tinto, con actitud audaz e inteligencia. Todos los equipos deportivos de Colegio y Universidad Vizcaya son conocidos como “Rapaces”, dicha mención obedece a que son identificados como los supremos competidores dentro de las instituciones de los diferentes niveles educativos. Ser parte de Rapaces va más allá de solo pertenecer a un equipo, simboliza la majestuosidad y congregación de elementos claves, tanto físicos como mentales, los cuales, dan un cauce estratégico a los elementos pertenecientes al grupo.</p>
          </v-col>
        </v-row>
      </v-img>

      <v-img
        v-show="$vuetify.breakpoint.xl"
        class="mx-0"
        :src="`${publicPath}imagenes/fondora2.png`"
      >
        <v-row justify="center">
          <v-col cols="10" sm="7" md="7" lg="8" xl="8" class="pt-12 pb-6">
            <h1 class="display-1 font-weight-bold text-uppercase pb-5">Forma parte del equipo</h1>
            <p
              class="body-1"
              style="text-align:justify;"
            >La Universidad Vizcaya de las Américas quiere fomentar dentro de la comunidad estudiantil, la integración de actividades físicas y recreativas, por tal motivo, nace el proyecto de unificar a los alumnos de la universidad dentro de las diferentes disciplinas deportivas. Dentro del sistema Vizcaya contamos con maestros capacitados para desarrollar las diferentes actividades dentro y fuera de cada Campus , los docentes se encargan de convocar, direccionar y entrenar a los alumnos que muestran interés por alguna disciplina deportiva mostrando audacia, perseverancia, entrega y dedicación.</p>
            <p
              class="body-1"
              style="text-align:justify;"
            >Surge la idea de tener un emblema distintivo, por lo cual, el departamento de Mercadotecnia de Patronato Cultural Vizcaya A.C. , determinó que debían ser representados por una figura que diera identidad propia a la institución, de esta manera nace “Uvaldo” (mascota oficial de la Universidad Vizcaya de las Américas), un águila real de color tinto, con actitud audaz e inteligencia. Todos los equipos deportivos de Colegio y Universidad Vizcaya son conocidos como “Rapaces”, dicha mención obedece a que son identificados como los supremos competidores dentro de las instituciones de los diferentes niveles educativos. Ser parte de Rapaces va más allá de solo pertenecer a un equipo, simboliza la majestuosidad y congregación de elementos claves, tanto físicos como mentales, los cuales, dan un cauce estratégico a los elementos pertenecientes al grupo.</p>
          </v-col>
        </v-row>
      </v-img>

      <v-row v-show="$vuetify.breakpoint.xs" justify="center">
        <v-col cols="10" sm="7" md="7" lg="8" xl="7" class="pt-12 pb-6">
          <h1 class="display-1 font-weight-bold text-uppercase pb-5">Forma parte del equipo</h1>
          <p
            class="body-1"
            style="text-align:justify;"
          >La Universidad Vizcaya de las Américas quiere fomentar dentro de la comunidad estudiantil, la integración de actividades físicas y recreativas, por tal motivo, nace el proyecto de unificar a los alumnos de la universidad dentro de las diferentes disciplinas deportivas. Dentro del sistema Vizcaya contamos con maestros capacitados para desarrollar las diferentes actividades dentro y fuera de cada Campus , los docentes se encargan de convocar, direccionar y entrenar a los alumnos que muestran interés por alguna disciplina deportiva mostrando audacia, perseverancia, entrega y dedicación.</p>
          <p
            class="body-1"
            style="text-align:justify;"
          >Surge la idea de tener un emblema distintivo, por lo cual, el departamento de Mercadotecnia de Patronato Cultural Vizcaya A.C. , determinó que debían ser representados por una figura que diera identidad propia a la institución, de esta manera nace “Uvaldo” (mascota oficial de la Universidad Vizcaya de las Américas), un águila real de color tinto, con actitud audaz e inteligencia. Todos los equipos deportivos de Colegio y Universidad Vizcaya son conocidos como “Rapaces”, dicha mención obedece a que son identificados como los supremos competidores dentro de las instituciones de los diferentes niveles educativos. Ser parte de Rapaces va más allá de solo pertenecer a un equipo, simboliza la majestuosidad y congregación de elementos claves, tanto físicos como mentales, los cuales, dan un cauce estratégico a los elementos pertenecientes al grupo.</p>
        </v-col>
      </v-row>
    </div>
    <div class="pb-12" v-if="city_options.sports.length>0">
      <v-row>
        <v-col cols="12" xs="12" class="py-12 pb-6 d-flex align-center justify-center">
          <v-slide-group show-arrows>
            <v-slide-item
              class="d-flex px-5 mx-5"
              style="word-wrap:break-word"
              v-for="item in city_options.sports"
              :key="item.sport.name"
              v-slot:default="{ active, toggle }"
            >
              <v-img
                height="60vh"
                max-width="300"
                :src="renderImage(item.sport.img)"
                gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"
                style="border-radius: 1rem;position:relative;"
              >
                <v-row
                  style="word-wrap:break-word;"
                  class="white--text align-center justify-center fill-height mx-0"
                >
                  <h4 class="white--text text-center text-uppercase display-1 font-weight-bold">
                    {{item.sport.name}}
                  </h4>
                </v-row>
              </v-img>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
    </div>
    <div
      class="white--text banner pa-12 title text-center"
      width="100vw"
    >Un profesional no solo nace de las aulas, sino también de la participación y desarrollo de los grupos que alientan a los miembros del mismo a ir más allá de sus propios sueños. “Rapaces representa perfectamente la unión y ejecución de elementos y destrezas que el profesional está dispuesto a adoptar por un objetivo común”.</div>
  </div>
</template>
<style lang="scss" scoped>
.pt-header {
  padding-top: 120px;
}

.banner {
  background-color: #212121;
  font-weight: normal;
}

.container {
  padding-left: 20%;
  padding-right: 20%;
}

ul {
  list-style: none;
}
.the-background {
  background-color: #681342;
}
</style>
<script>
import Estatus from "../components/Estatus.vue";
import LeftImage from "../components/LeftImage.vue";
import { mapState } from "vuex";
export default {
  components: {
    Estatus,
    LeftImage
  },
  mounted(){
  },
  data: () => ({
    publicPath: process.env.BASE_URL,
    centeractive: true,
    model: null,
    valores: [
      "Lealtad",
      "Disciplina",
      "Espíritu de Servicio",
      "Respeto",
      "Responsabilidad",
      "Honestidad"
    ],
    deportes: [
      {
        image: "/imagenes/deportes2/1.jpg",
        name: "Voleibol"
      },
      {
        image: "/imagenes/deportes2/2.jpg",
        name: "Atletismo"
      },
      {
        name: "Básquetbol",
        image: "/imagenes/deportes2/3.jpg"
      },
      {
        name: "Fútbol",
        image: "/imagenes/deportes2/4.jpg"
      }
    ],
    textArray: [
      {
        text:
          "Promover en nuestros alumnos el desarrollo integral, en todos sus potenciales tanto humano, físico, psíquico, emocional, afectivo y social, fomentando que su aprendizaje parta de los conocimientos que ya poseen y tengan un valor para ellos."
      },
      {
        text:
          "Propiciar la capacidad de interactuar respetuosa y afectuosamente, cooperando con los otros, haciendo de los educandos, seres observadores, críticos, reflexivos y humanamente formados."
      }
    ],
    items: [
      {
        src: "imagenes/Articulo1.jpg"
      },
      {
        src: "imagenes/Articulo2.png"
      },
      {
        src: "imagenes/Articulo3.png"
      },
      {
        src: "imagenes/sistema_vizcaya.jpg"
      }
    ]
  }),
  methods:{
    renderImage(image){
      if(image.indexOf("https")<0){
        return "https://adminuva.tidingo.com"+image;
      }else{
        return image;
      }
    },
  },
  computed: {
    ...mapState({
      campus: state => state.cities.campus,
      city_options: state => state.cities.city_options,
      city_selected: state => state.cities.city_selected,
      cities: state => state.cities.cities,
      vida: state => state.cities.vida,
      link_location: state => state.cities.link_location,
      link_information: state => state.cities.link_information,
    })
  }
};
</script>
